import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { default as ScanInstructions } from "@/assets/illustrations/scanInstructions.svg"
import Heading from "@/globalComponents/atoms/Heading"
import Text from "@/globalComponents/atoms/Text"

export const Route = createFileRoute("/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  return (
    <div className="home">
      <Heading level={2} as={1} className="center">
        {t("home.header")}
      </Heading>
      <Text level={2} className="center">
        {t("home.body")}
      </Text>
      <ScanInstructions />
    </div>
  )
}
